import { css } from '@emotion/react';
import { breakpoints } from '@nike/nike-design-tokens';
const { podiumCdsBreakpointM } = breakpoints;

export const focusRingStyle = css`
  &:focus-visible {
    box-shadow: 0 0 0 2px var(--podium-cds-color-box-focus-ring);
  }
`;
export const navScrollable = 'nav-scrollable';
export const navMenuOpen = 'nav-menu-open';

export const desktopOnly = `min-width: ${podiumCdsBreakpointM}`;
export const mobileOnly = `max-width: ${parseInt(podiumCdsBreakpointM) - 1}px`;

export const glitchStyles = css`
  .glitch-effect {
    position: relative;
  }

  .glitch-effect::before,
  .glitch-effect::after {
    content: attr(data-text);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    pointer-events: none;
    user-select: none;
  }

  .glitch-effect::before {
    left: 2px;
    text-shadow: -2px 0 #b400ff;
    animation: glitch-1 2s linear infinite;
  }

  .glitch-effect::after {
    left: -2px;
    text-shadow: -2px 0 #00e639;
    animation: glitch-2 2s linear infinite;
  }

  @keyframes glitch-1 {
    0%,
    79% {
      clip-path: inset(0 0 100% 0);
    }
    80% {
      clip-path: inset(42% 0 58% 0);
    }
    83% {
      clip-path: inset(12% 0 65% 0);
    }
    86% {
      clip-path: inset(85% 0 2% 0);
    }
    89% {
      clip-path: inset(50% 0 30% 0);
    }
    92% {
      clip-path: inset(67% 0 15% 0);
    }
    95% {
      clip-path: inset(20% 0 62% 0);
    }
    96%,
    100% {
      clip-path: inset(0 0 100% 0);
    }
  }

  @keyframes glitch-2 {
    0%,
    79% {
      clip-path: inset(0 0 100% 0);
    }
    80% {
      clip-path: inset(65% 0 20% 0);
    }
    83% {
      clip-path: inset(30% 0 55% 0);
    }
    86% {
      clip-path: inset(78% 0 5% 0);
    }
    89% {
      clip-path: inset(10% 0 75% 0);
    }
    92% {
      clip-path: inset(45% 0 40% 0);
    }
    95% {
      clip-path: inset(88% 0 8% 0);
    }
    96%,
    100% {
      clip-path: inset(0 0 100% 0);
    }
  }

  @media screen and (prefers-reduced-motion: reduce), (update: slow) {
    .glitch-effect::before,
    .glitch-effect::after {
      content: none;
    }
  }
`;
